<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>
<script>
import { key } from '@/env'
import socket from '@/socket'
export default {
	data() {
		return {

		}
	},
	methods: {
		checkUser() {
			const user  = JSON.parse(window.localStorage.getItem(key.user));
			const token = window.localStorage.getItem(key.token);
			if (user && token) {
				this.$store.commit('loginSuccess', user);
				this.$store.commit('setToken', token);
			}

			const wyy_token = window.localStorage.getItem(key.wyy_token);
            if (wyy_token) {
				this.$store.commit('wyyLoginSuccess', wyy_token);
                this.$api.refreshWyyLoginStatus();
            }
		},
		init() {
			this.checkUser();
			// let _self = this;
			// socket.init(() => {
			//     this.checkUser();
			// });
		},
	},
	mounted() {
        
	},
	created() {
		this.init();
	},
}

</script>
<style lang="less">
@import "./assets/css/colorUi.css";
@import "./assets/css/iconfont/iconfont.css";
@import "./assets/css/animate.css";
/* 公共 */
* {
	margin: 0;
	padding: 0;
}

html,
body,
#app,
.wrapper {
	width: 100%;
	height: 100%;
	overflow: hidden;
	font-size: 10px;
}

body {
	font-family: "PingFang SC", "Helvetica Neue", Helvetica, "microsoft yahei",
		arial, STHeiTi, sans-serif;
}

a {
	text-decoration: none;
}

.no-data-list {
	height: 500px;
	line-height: 500px;
}
::-webkit-scrollbar {
	/*滚动条整体样式*/
	width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
	height: 4px;
}
::-webkit-scrollbar-thumb {
	/*滚动条里面小方块*/
	border-radius: 5px;
	// -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	// background: #409eff;
}
::-webkit-scrollbar-track {
	/*滚动条里面轨道*/
	// -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	border-radius: 0;
	// background: #d9ecff;
}

/* 修复markdown编辑器全屏模式下其他组件会造成遮挡的问题 */
#markdown .fullscreen {
	z-index: 999 !important;
}
.ant-dropdown {
    z-index: 1100;
}
.ant-message {
    z-index: 9999;
}
.ant-menu {
    background-color: transparent !important;
}
.el-loading-mask {
    z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/App.vue